<div class="row">
  <div class="flex justify-end">
    <button mat-flat-button color="primary" (click)="addBlankDevice()" size="2x">Add Device</button>
  </div>
</div>
<form [formGroup]="parentForm" *ngIf="parentForm" (change)="setDirtyForm()">
  <ng-container formArrayName="devices">
    <div *ngFor="let device of devices.controls; index as i" class="card" style="width: 40rem;">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            {{(device.get('deviceName').value) ? device.get('deviceName').value : 'New Device'}}
          </mat-expansion-panel-header>
          <div [formGroup]="device">
            <input id="id{{i}}" formControlName="id" type="text" hidden/>
            <div class="flex justify-end">
              <mat-icon matTooltip="Remove device" matTooltipPosition="right" (click)="removeDevice(i)" style="cursor: pointer">close</mat-icon>
            </div>
            <br />
            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label for="deviceName{{i}}">Device Name</mat-label>
                <input matInput id="deviceName{{i}}" formControlName="deviceName" type="text" class="form-control"/>
              </mat-form-field>
            </div>
            <br />
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>
  @if (devices.controls.length) {
    <div class="flex items-center justify-end" style="margin-top: 1rem">
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!parentForm.valid" style="margin-right: 1rem">Save</button>
      <button mat-flat-button color="warn" (click)="cancel()" >Cancel</button>
    </div>
  }
</form>
